/**
 * List component for transactions, managing list content and implementing event handler
 *
 * Properties:
 *
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React from "react";

import AppErrorListItem from "./AppErrorListItem";

const AppErrorsList = (props) => {
  return (
    <>
      <div
        id="inb-c-main-errors"
        className="inb-c-listing off-canvas-content"
        data-off-canvas-content=""
        key="inb-c-main-errors"
      >
        <br />
        {props.errors.map((resource, index) => {
          return (
            <>
              <AppErrorListItem
                error={props.errors[index]}
                key={index + `_err`}
                index={index}
                filterChangedHandle={props.filterChangedHandle}
                filter={props.filter}
                dispatch={props.dispatch}
                _index={index}
                setInitialized={props.setInitialized}
              />
            </>
          );
        })}
      </div>
    </>
  );
};
export default AppErrorsList;
